import React from "react";
import BrandOverlayForm from "./services/BrandOverlayForm";
import { brandOverlayDefaults } from "./brandOverlay";

/** Processing steps whose config is too shaped for DynamicServiceForm (nested
 *  lists, per-row validation) get a purpose-built form here. Everything else
 *  stays declarative in stepDefinitions.json. Mirrors SYNDICATOR_REGISTRY. */
export interface ProcessingFormProps {
  config: any;
  onChange: (field: string, value: any) => void;
}

export interface ProcessingEntry {
  Component: React.ComponentType<ProcessingFormProps>;
  defaults: Record<string, any>;
}

export const PROCESSING_REGISTRY: Record<string, ProcessingEntry> = {
  brandOverlay: { Component: BrandOverlayForm, defaults: brandOverlayDefaults },
};
